import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import {
    CalculatorStepAccordion,
    useForm,
} from '@ratehub/base-ui';
import { AmortizationSchedule } from '@ratehub/mtg-common';
import { PAYMENT_FREQUENCIES } from '@ratehub/documents/mtg-journey-document/stable';


function AmortizationCalcChartStep({
    stepNumber,

    ...otherProps
}) {
    const form = useForm();

    return (
        <CalculatorStepAccordion
            title={(
                <FormattedMessage
                    id="calculators.Amortization.AmortizationScheduleTitle"
                    defaultMessage="Amortization schedule"
                />
            )}
            stepNumber={stepNumber}
            canBeDisabled
            {...otherProps}
        >
            <AmortizationSchedule
                totalMortgage={form.values.totalMortgage ?? form.values.loanAmount}
                mortgageRate={form.values.mortgageRate ?? form.values.loanRate}
                amortization={parseInt(form.values.amortizationPeriod ?? form.values.loanPeriod ?? '25')} // if neither form value is available use default of 25 years
                paymentFrequency={PAYMENT_FREQUENCIES.MONTHLY} //calculator assumes monthly payments
                isTableIncluded
            />
        </CalculatorStepAccordion>
    );
}

AmortizationCalcChartStep.propTypes = {
    stepNumber: PropTypes.number.isRequired,
};

export default observer(AmortizationCalcChartStep);
